import React from "react";
import "./footer.css";

export default function footer() {
  return (
    <div id="Footer" className="centerIt">
      <p>This Portfolio website is created on React framework</p>
    </div>
  );
}
